module.exports = __webpack_public_path__ + "img/star.5f031b9c.svg";